"use strict";

define('rs/services/report.service',['rs/services/abstract.service', 'rs/models/report', 'rs/models/download', 'rs/validation/report.validation', 'e3-modal'], function (AbstractService, ReportModel, DownloadGenerator, ReportValidator, E3Modal) {
  var ReportService = AbstractService.extend({
    properties: ['reportTypeName', 'reportType'],
    getReports: function getReports(force) {
      return this.cache('reports', this.requestReports, force);
    },
    getType: function getType(force) {
      return this.cache('type', this.requestReportType, force);
    },
    createReportDefinition: function createReportDefinition(data) {
      var newReport = new ReportModel(data);
      newReport.setType(this.getReportType());
      return ReportValidator.validate(newReport).bind(this).then(function () {
        return ReportModel.requestCreateReport(newReport).bind(this).then(function (report) {
          newReport.updateWith(report);
          return report;
        })["finally"](this.showLoading());
      });
    },
    deleteReportDefinition: function deleteReportDefinition(report) {
      return E3Modal.BtnMsgModal.show({
        title: 'Delete "' + report.name + '"',
        message: 'Are you sure you want to delete this report?',
        buttons: ['Cancel', 'Yes']
      }).bind(this).then(function (btn) {
        if (btn == 'Yes') {
          return ReportModel.requestDeleteReport(report.id).bind(this).then(function () {
            return this.update('reports');
          })["finally"](this.showLoading());
        }
      });
    },
    runReportDefinition: function runReportDefinition(report) {
      var options = {
        method: 'GET',
        url: ReportModel.getCsvURL(report)
      };
      DownloadGenerator.requestDownload({
        v: 'csvh'
      }, options);
    },
    requestDefinitionResults: function requestDefinitionResults(definition) {
      if (!definition.type) {
        definition.type = this.getReportType();
      }
      return ReportModel.requestReportDefinitionResults(definition);
    },
    requestReportResults: function requestReportResults(report) {
      return ReportModel.requestReportResults(report);
    },
    saveReportDefinition: function saveReportDefinition(report) {
      return ReportValidator.validate(report).bind(this).then(function () {
        return ReportModel.requestUpdateReport(report).bind(this).then(function (model) {
          report.updateWith(model);
        })["finally"](this.showLoading());
      });
    },
    requestColumns: function requestColumns() {
      var type = this.getReportType();
      return ReportModel.requestReportColumns(type.id);
    },
    requestReportDefinition: function requestReportDefinition(reportDefinitionId) {
      return ReportModel.requestReport(reportDefinitionId);
    },
    requestReports: function requestReports() {
      var type = this.getReportType();
      return ReportModel.requestReports(type.id);
    },
    requestReportType: function requestReportType() {
      return this.requestReportTypes().bind(this).then(function (types) {
        var type = _.findWhere(types, {
          name: this.getReportTypeName()
        });
        this.setReportType(type);
      });
    },
    requestReportTypes: function requestReportTypes() {
      return ReportModel.requestReportTypes();
    },
    showLoading: function showLoading() {
      return this.getApp().showLoading();
    }
  });
  return ReportService;
});

